import request from 'api/request';

export default function openTicketRoute(id, virtualUrl = '') {
  return request({
    url: `/tickets/${id}/open`,
    method: 'POST',
    data: { virtualUrl },
  });
}
